import _ from 'lodash';
import DateTimeUtil from './DateTime.js';
import {DocumentModels, ValidationMessages} from '../constants/IDVerificationConstants.js';

function getCrossInputValidationResult(sourceFieldLabel, sourceFieldValue, targetFieldLabel, targetFieldValue, comparison) {
    let isValid = true;
    let errorList = [];

    switch (comparison) {
        case 'greaterThan':
            const sourceValue = DateTimeUtil.dateStringToDate(sourceFieldValue);
            const targetValue = DateTimeUtil.dateStringToDate(targetFieldValue);
            if (!(sourceValue > targetValue)) {
            isValid = false;
            errorList.push({
                errorHeading: 'Invalid ' + sourceFieldLabel,
                errorMessage: sourceFieldLabel + ' must be greater than ' + targetFieldLabel
            });
        }
        break;
    default:
        isValid: false
    }

    return {
        isValid: isValid,
        errorList: errorList
    }
}

function getInputValidationResult(docTypeKey, docId, investorId, formInputValue, formInputName) {
    const docModel = _.cloneDeep(_.find(DocumentModels, { reactKey: docTypeKey }));
    const formInputMeta = _.find(docModel.meta, { model: formInputName });
    const defaultValue = formInputMeta.defaultValue ? formInputMeta.defaultValue: null;
    const label = (formInputMeta.label).toLowerCase();
    const mandatory = formInputMeta.mandatory;
    const validation = formInputMeta.validation;

    let isValid = false;
    let errorList = [];

    if (mandatory && !formInputValue && !defaultValue) {
        isValid = false;
        errorList.push({
            errorHeading: ValidationMessages.missingFieldHeader.replace('{{label}}', label),
            errorMessage: ValidationMessages.missingFieldMessage.replace('{{label}}', label)
        });
    } else if (!mandatory && !formInputValue) { 
        // optional field
        isValid = true;
    } else if (mandatory && !formInputValue && defaultValue) {
        isValid = true;
    } else if (mandatory && (typeof formInputValue !== 'undefined') && formInputValue === '') {
        // errorList: doesnt exist
        isValid = false;
        errorList.push({
            errorHeading: ValidationMessages.missingFieldHeader.replace('{{label}}', label),
            errorMessage: ValidationMessages.missingFieldMessage.replace('{{label}}', label)
        });
    } else if ((typeof formInputValue !== 'undefined') && formInputValue !== '' && validation) {
        let result = getFieldInputVerification(validation, formInputValue, docTypeKey);
        isValid = result.isValid;
        if (result.error !== null) {
            errorList.push(result.error);
        }
    } else if ((typeof formInputValue !== 'undefined') && formInputValue !== '' && !validation) {
        isValid = true;
    } else { 
        // unhandled validation case
        isValid = false;
        errorList.push({
            errorHeading: ValidationMessages.missingFieldHeader.replace('{{label}}', label),
            errorMessage: ValidationMessages.missingFieldMessage.replace('{{label}}', label)
        });
    }

    return {
        isValid: isValid,
        errorList: errorList
    }
}

function getFieldInputVerification(validation, formInputValue, docTypeKey) {
    let isValid = false;
    let error = null;

    switch (validation) {
    case 'issueDate':
        const isIssueDateExist = DateTimeUtil.isDateExist(formInputValue);
        const isIssueDateFuture = DateTimeUtil.isFutureDate(new Date(), formInputValue) && !DateTimeUtil.isDateToday(new Date(), formInputValue);

        if (!isIssueDateExist) {
            isValid = false;
            error = {
                errorHeading: ValidationMessages.invalidIssueDate,
                errorMessage: ValidationMessages.invalidDateFormat
            };
        } else if (isIssueDateFuture) {
            isValid = false;
            error = {
                errorHeading: ValidationMessages.invalidIssueDate,
                errorMessage: ValidationMessages.futureIssueDate
            };
        } else {
            isValid = true;
            error = null;
        }
        break;
    case 'expiryDate':
        const isExpiryDateExist = DateTimeUtil.isDateExist(formInputValue);
        const isExpiryDateFuture = DateTimeUtil.isFutureDate(new Date(), formInputValue) || DateTimeUtil.isDateToday(new Date(), formInputValue);

        if (!isExpiryDateExist) {
            isValid = false;
            error = {
                errorHeading: ValidationMessages.expiryDateFormat,
                errorMessage: ValidationMessages.invalidDateFormat
            }
        }else if (!isExpiryDateFuture) {
            switch (docTypeKey) {
                case 'FPP':
                    isValid = false;
                    error = {
                        errorHeading: ValidationMessages.invalidExpiryDate,
                        errorMessage: ValidationMessages.expiredIntPassport
                    }
                    break;
                case 'ADL':
                case 'ADC':
                case 'FDL':
                    isValid = false;
                    error = {
                        errorHeading: ValidationMessages.invalidExpiryDate,
                        errorMessage: ValidationMessages.expiredLicense
                    }
                    break;
                default:
                    isValid = false;
                    error = {
                        errorHeading: ValidationMessages.invalidExpiryDate,
                        errorMessage: ValidationMessages.pastExpiredDate
                    }
            }
        } else {
            isValid = true;
            error = null;
        }
        break;
    case 'expiryDateMinus2Years':
        const isDateExist = DateTimeUtil.isDateExist(formInputValue);
        const isDateLessThan2YearsFromToday = DateTimeUtil.isDateLessThan2YearsFromToday(formInputValue);

        if (!isDateExist) {
            isValid = false;
            error = {
                errorHeading: ValidationMessages.invalidExpiryDate,
                errorMessage: ValidationMessages.invalidDateFormat
            };
        } else if (!isDateLessThan2YearsFromToday) {
            if (docTypeKey === 'APP') {
                isValid = false;
                error = {
                    errorHeading: ValidationMessages.invalidExpiryDate,
                    errorMessage: ValidationMessages.expiredAusPassport
                };
            } 
        } else {
            isValid = true;
            error = null;
        }
        break;
    default: 
        isValid = false;
    }

    return {
        isValid: isValid,
        error: error
    }
}

const IdVerificationFieldValidationHelper = {
    getInputValidationResult: getInputValidationResult,
    getCrossInputValidationResult: getCrossInputValidationResult
};

export default IdVerificationFieldValidationHelper;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./utils/IdVerificationFieldValidationHelper.js